<span id="createReverseAuditWizard_createFromExisting">
  <h1>Step 1: Import From Existing Rate Audit (Select audit to import)</h1>

  <kendo-grid class="existingRateAuditKendoGrid" [data]="view" [skip]="state.skip" [sort]="state.sort" [sortable]="true"
    [selectable]="{enabled:true,mode:'single'}" [selectedKeys]="selectedAudit" [kendoGridSelectBy]="'AuditID'"
    (selectionChange)="selectionChange($event)" (dataStateChange)="dataStateChange($event)" [scrollable]="'scrollable'">
    <kendo-grid-column field="" title="Audit ID">
      <ng-template kendoGridHeaderTemplate let-column>
        {{column.title}}&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;"
          src="../../../assets/sort-button.png" (click)="onTemplateClick($event)" />
      </ng-template>
      <ng-template kendoGridCellTemplate let-rowIndex="rowIndex" let-dataItem>
        <div [class]="(dataItem.hovering?'highlight':'')" (mouseenter)="divMouseEnter($event, dataItem)"
          (mouseleave)="divMouseLeave($event, dataItem)">
          <span>{{dataItem.QuickAuditID ? dataItem.QuickAuditID : dataItem.UniversalAuditID}}</span> </div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="CustomerAccountNameLowerCase" title="Name">
      <ng-template kendoGridHeaderTemplate let-column let-rowIndex="rowIndex">
        {{column.title}}&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;"
          src="../../../assets/sort-button.png" (click)="onTemplateClick($event)" />
      </ng-template>
      <ng-template kendoGridCellTemplate let-rowIndex="rowIndex" let-dataItem>
        <div [class]="(dataItem.hovering?'highlight':'')" (mouseenter)="divMouseEnter($event, dataItem)"
          (mouseleave)="divMouseLeave($event, dataItem)"><span>{{dataItem.CustomerAccountName}}</span></div>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
</span>
